import React from 'react';
import classNames from 'classnames';
import MUIRadio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  error: {
    color: 'red'
  }
});

export const RadioBase = ({
  checked,
  color,
  disabled,
  id,
  inputRef,
  label,
  onChange,
  value,
  className,
  isError
}: any) => {
  const classes = useStyles();
  return (
    <FormControlLabel
      control={
        <MUIRadio
          checked={checked}
          color={color}
          disabled={disabled}
          id={id}
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          className={classNames(isError && classes.error, {
            [className]: className
          })}
          data-testid="radio"
        />
      }
      label={label}
      labelPlacement="end"
    />
  );
};

export default RadioBase;
